export default "__VITE_ASSET__Iod3MrxT__"